module.exports = __webpack_public_path__ + "static/about-kamil.f14a5362.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-kamil.jpg
// module id = 651
// module chunks = 196067925415476